import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { handleChangeDataModalEditTransFactorNum } from '../../../../redux/actions/partials/modals/modalEditTransFactorNum';
import { handleChangeInputTransPage } from '../../../../redux/actions/pages/trans';
import { BASE_SITE, EDIT_FACTOR_NUM } from '../../../../apis';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import axios from "axios";
import * as qs from "querystring";


const ModalEditTransFactorNum = (props) => {

	const dispatch = useDispatch();

	const { isOpen, factorNum, transNum, transKey } = useSelector(state => state.modalEditTransFactorNum);
	const { trans } = useSelector(state => state.trans);
	const { token } = useSelector(state => state.login);

	const handleClose = () => {
        dispatch(handleChangeDataModalEditTransFactorNum('isOpen', false));
    };    

    const handleChangeInputs = (event) => {
    	const {name, value} = event.target;
    	dispatch(handleChangeDataModalEditTransFactorNum(name, value));
    };

    const handleSubmitForm = () => {
    	if(factorNum.length > 2) {
    		dispatch(handleSetBackdropLoading(true));


	    	axios({
	            method: 'post',
	            url: BASE_SITE + EDIT_FACTOR_NUM,
	            data: qs.stringify({
	                factor: factorNum,
	                trans: transNum,
	            }), headers: {
	                'Accept': 'application/json',
	                'Content-Type': 'application/x-www-form-urlencoded', 
	                'Authorization': token, 
	            },
	        }).then((response) => {
	            switch (response.data.status) {
	                case 'error':
	                	dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'top', horizontal: 'right'}));
	                    break;
	                case 'ok':
	                	dispatch(handleSetOpenCustomSnackbar(true, {message: 'شماره فاکتور با موفقیت ویرایش شد', severity: 'success', vertical: 'top', horizontal: 'right'}));

	                    dispatch(handleChangeDataModalEditTransFactorNum('factorNum', ''));
	                    dispatch(handleChangeDataModalEditTransFactorNum('transNum', 0));
	                    dispatch(handleChangeDataModalEditTransFactorNum('isOpen', false));

	                    let newTrans = [...trans];
	                    newTrans[transKey].factor_num = factorNum;
	                    dispatch(handleChangeInputTransPage('trans', newTrans));

	                    break;
	                default:
	                	dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
	            }
	            dispatch(handleSetBackdropLoading(false));
	        }, () => {
	            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
	            dispatch(handleSetBackdropLoading(false));
	        });
    	}
	    else
	    	dispatch(handleSetOpenCustomSnackbar(true, {message: 'شماره فاکتور را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));	
    };

    return (
        <Modal show={isOpen} onHide={handleClose} className={`modal fade text-xs-left ${isOpen ? 'in' : ''}`} dialogClassName='modal-dialog modal-dialog-centered modal-fullscreen-sm-down' style={{marginTop: '90px'}}>
        	<div className="modal-dialog modal-lg" role="document" style={{marginTop: '0', marginBottom: '0'}}>
        		<div className="modal-content" >
        			<div className="modal-header">
		                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
		                    <span aria-hidden="true">&times;</span>
		                </button>
		                <h4 className="modal-title" id="myModalLabel17">ویرایش شماره فاکتور</h4>
		            </div>
		            <form>
			            <div className="modal-body">
			            	<label>شماره فاکتور فروشگاه: </label>
							<div className="form-group">
								<input type="text" placeholder="" className="form-control" name="factorNum" value={factorNum} onChange={handleChangeInputs} />
							</div>
			            </div>
			            <div className="modal-footer">
			                <button type="button" className="btn grey btn-outline-secondary" data-dismiss="modal" onClick={handleClose}>بستن</button>
			                <button type="button" className="btn btn-outline-primary ml-2" data-dismiss="modal" onClick={handleSubmitForm}>ویرایش</button>
			            </div>
		            </form>
        		</div>
        	</div>

        </Modal>
    );
}

export default ModalEditTransFactorNum;
